import React from "react";
import { useSelector } from "react-redux";
import { Link } from "react-router-dom";

import { selectHasSession } from "features/auth/authSlice";

import paths from "routes/paths";

/**
 * "contact us" on the pages shown to visitors and signed-in users alike (404, 500).
 *
 * A signed-in user goes to the feedback form, which knows who they are; anyone
 * else to the public technical issue form (#99, #119).
 */
const ContactUsLink = () => {
  const hasSession = useSelector(selectHasSession);
  return (
    <Link
      to={hasSession ? paths.feedback : paths.cardTechnicalIssue}
      className="ms-1"
    >
      contact us
    </Link>
  );
};

export default ContactUsLink;
